/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner';

/**
 * 
 * @export
 * @interface CreateLeadWaitlistUpdate201Response
 */
export interface CreateLeadWaitlistUpdate201Response {
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner}
     * @memberof CreateLeadWaitlistUpdate201Response
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInner;
}

/**
 * Check if a given object implements the CreateLeadWaitlistUpdate201Response interface.
 */
export function instanceOfCreateLeadWaitlistUpdate201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateLeadWaitlistUpdate201ResponseFromJSON(json: any): CreateLeadWaitlistUpdate201Response {
    return CreateLeadWaitlistUpdate201ResponseFromJSONTyped(json, false);
}

export function CreateLeadWaitlistUpdate201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadWaitlistUpdate201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerFromJSON(json['data']),
    };
}

export function CreateLeadWaitlistUpdate201ResponseToJSON(value?: CreateLeadWaitlistUpdate201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistUpdatesInnerToJSON(value.data),
    };
}

